import { NOTIFICATION_TOKEN } from "./actionTypes";
import { NOTIFICATION_TOKEN_URL } from "../../configs";
import Axios from "axios";


import {getToken, onMessage} from "firebase/messaging";
import {getFirebaseMessaging} from "../../firebase";

export const saveNotificationToken = (pushToken, userId, authToken) => async (dispatch) => {
	try {

		await Axios.post(NOTIFICATION_TOKEN_URL, {
			push_token: pushToken,
			user_id: userId,
			token: authToken,
		});

		// Store token + timestamp
		localStorage.setItem("pushToken", pushToken);
		localStorage.setItem("pushTokenLastSync", Date.now().toString());

		dispatch({
			type: NOTIFICATION_TOKEN,
			payload: pushToken,
		});

		console.log("Notification Token Saved");
	} catch (error) {
		console.error("Failed to save notification token", error);
	}
};

export const registerPush = (user) => async (dispatch) => {
	if (!user?.success) return;
	if (localStorage.getItem("enablePushNotification") !== "true") return;

	const permission = await Notification.requestPermission();
	if (permission !== "granted") return;

	const messaging = await getFirebaseMessaging();
	console.log("before message");
	if (!messaging) {
		console.log("there is no messaging: ", messaging);
		return;
	}

	console.log("before registration: ", messaging)
	console.log("registration: ");

	const token = await getToken(messaging, {
		vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
		serviceWorkerRegistration: await navigator.serviceWorker.register("/firebase-messaging-sw.js")
	});

	console.log("token: ", token);

	if (!token) return;

	const storedToken = localStorage.getItem("pushToken");
	const lastChecked = parseInt(
		localStorage.getItem("pushTokenSession"), 10) || 0;

	const now = Date.now();
	const oneDay = 24 * 60 * 60 * 1000;

	const tokenChanged = token !== storedToken;
	const sessionExpired = now - lastChecked <= oneDay;

	if (tokenChanged || sessionExpired) {
		console.log("token Changed: ", sessionExpired);
		console.log("New or changed FCM token");
		dispatch(saveNotificationToken(token, user.data.id, user.data.auth_token));
	}
};

export const registerDeliveryPush = (user, onForegroundMessage) => {
	return async (dispatch) => {
		if (!user?.success) return;
		if (localStorage.getItem("enablePushNotification") !== "true") return;

		const messaging = await getFirebaseMessaging();
		if (!messaging) return;

		const permission = await Notification.requestPermission();
		if (permission === "granted") {
			try {
				const token = await getToken(messaging, {
					vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
					serviceWorkerRegistration: await navigator.serviceWorker.register("/firebase-messaging-sw.js")
				});


				if (!token) return;

				const storedToken = localStorage.getItem("pushToken");
				const lastChecked = parseInt(
					localStorage.getItem("pushTokenSession"), 10) || 0;

				const now = Date.now();
				const oneDay = 3 * 60 * 60 * 1000;

				const tokenChanged = token !== storedToken;
				const sessionExpired = now - lastChecked <= oneDay;

				if (tokenChanged || sessionExpired) {
					console.log("token Changed: ", sessionExpired);
					console.log("New or changed FCM token");
					dispatch(saveNotificationToken(token, user.data.id, user.data.auth_token));
				}
			} catch (err) {
				console.error("Error getting FCM token:", err);
			}
		}
		// }

		// ---- Listen for foreground messages ----
		if (typeof onForegroundMessage === "function") {
			onMessage(messaging, (payload) => {
				console.log("Foreground message received:", payload);
				onForegroundMessage(payload);
			});
		}
	};
};

// export const registerDeliveryPush = (user, onForegroundMessageCallback) => async (dispatch) => {
// 	if (!user?.success) return;
// 	if (localStorage.getItem("enablePushNotification") !== "true") return;
//
// 	const messaging = await getFirebaseMessaging();
// 	if (!messaging) return;
//
// 	// ---- 24-hour token refresh logic ----
// 	// const lastChecked = parseInt(localStorage.getItem("pushTokenSession"), 10) || 0;
// 	// const now = Date.now();
// 	// const oneDay = 24 * 60 * 60 * 1000; // 24 hours in ms
// 	//
// 	// if (!lastChecked || now - lastChecked >= oneDay) {
// 		const permission = await Notification.requestPermission();
// 		if (permission === "granted") {
// 			try {
// 				const token = await getToken(messaging, {
// 					vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
// 					serviceWorkerRegistration: await navigator.serviceWorker.register("/firebase-messaging-sw.js")
// 				});
//
// 				if (token) {
// 					console.log("New FCM token:", token);
// 					dispatch(saveNotificationToken(token, user.data.id, user.data.auth_token));
// 				}
// 			} catch (err) {
// 				console.error("Error getting FCM token:", err);
// 			}
// 		}
// 	// }
//
// 	// ---- Listen for foreground messages ----
// 	if (typeof onForegroundMessageCallback === "function") {
// 		onMessage(messaging, (payload) => {
// 			console.log("Foreground message received:", payload);
// 			onForegroundMessageCallback(payload);
// 		});
// 	}
// };


// export async function registerDeliveryUserPush(delivery_user) {
// 	if (!delivery_user?.success) return;
//
// 	// Check if push notifications are enabled
// 	if (localStorage.getItem("enablePushNotification") !== "true") return;
//
// 	const messaging = await getFirebaseMessaging();
// 	if (!messaging) return;
//
// 	try {
// 		// Request permission
// 		const permission = await Notification.requestPermission();
// 		if (permission !== "granted") return;
//
// 		// Register service worker and get token
// 		const token = await getToken(messaging, {
// 			vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
// 			serviceWorkerRegistration: await navigator.serviceWorker.register("/firebase-messaging-sw2.js")
// 		});
//
// 		if (token) {
// 			// Send token to backend
// 			saveNotificationToken(token, delivery_user.data.id, delivery_user.data.auth_token);
// 		}
//
// 		// Listen to messages from service worker (foreground messages)
// 		onMessage(messaging, (payload) => {
// 			console.log("Foreground message received:", payload);
// 		});
//
// 	} catch (err) {
// 		console.log("Unable to get permission or token:", err);
// 	}
// }
// export const registerPush = (user) => async (dispatch) => {
// 	if (!user?.success) return;
//
// 	let existingToken = localStorage.getItem("pushToken");
// 	let lastChecked = localStorage.getItem("pushTokenSession");
// 	if(existingToken && (lastChecked > new Date().getHours())) {
// 		const token = await getToken(messaging, {
// 			vapidKey: "BMZjTBwZXWlQKpjLxPka-mtf5DgA0DmrsbEZ4Eb7pFcfL1v4eq4tTLUk9kbDfpCHrFHC5j5lfuzB7TF_1G1H4Q4",
// 			serviceWorkerRegistration: await navigator.serviceWorker.register(
// 				"/firebase-messaging-sw2.js"
// 			)
// 		});
//
// 		if(token === existingToken) {
// 			localStorage.setItem("pushTokenSession", new Date());
// 			return;
// 		}
//
// 		await dispatch(saveNotificationToken());
// 	}
//
// 	if (localStorage.getItem("enablePushNotification") !== "true") return;
//
// 	const permission = await Notification.requestPermission();
// 	if (permission !== "granted") return;
//
// 	const messaging = await getFirebaseMessaging();
// 	if (!messaging) return;
//
// 	const token = await getToken(messaging, {
// 		vapidKey: "BMZjTBwZXWlQKpjLxPka-mtf5DgA0DmrsbEZ4Eb7pFcfL1v4eq4tTLUk9kbDfpCHrFHC5j5lfuzB7TF_1G1H4Q4",
// 		serviceWorkerRegistration: await navigator.serviceWorker.register(
// 			"/firebase-messaging-sw2.js"
// 		)
// 	});
//
// 	if (token) {
// 		console.log("token: ", token);
// 		dispatch(saveNotificationToken(token, user.data.id, user.data.auth_token));
// 	}
// }